



































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import ActivitySwitch from "@/components/common/edit/ActivitySwitch.vue";
import getUrlParam from '@/common/utils/getUrlParam';

import { resolveBoundaryValue } from '@/common/utils/format';

interface Payload {
  status?: boolean;
  number?: number;
}

@Component({
  components: {
    "activity-switch": ActivitySwitch
  }
})
export default class LimitNumber extends Vue {
  @Getter("isLimited") isLimited!: boolean;
  @Getter("limitNum") getterLimitNum!: number;
  @Getter("section") section!: object;

  @Action("switchLimitNumber") switchLimitNumber!: Function;
  @Action("changeLimitNumber") changeLimitNumber!: Function;

  type: string = getUrlParam("type") as string;

  get limitNumber(): number {
    console.log(this.getterLimitNum)
    return this.getterLimitNum;
  }

  set limitNumber(val: number) {
    const payload: Payload = {
      number: val
    };
    this.changeLimitNumber(payload);
  }

  handleSwitch(status: boolean): void {
    if (this.type !== "reEdit") {
      const payload: Payload = {
        status
      };
      this.switchLimitNumber(payload);
    }
  }

  handleInputBlur(value: number) {
    const _value = resolveBoundaryValue(value);
    this.changeLimitNumber({ number: _value });
  }
}
